module.exports = "https://coursera_assets.s3.amazonaws.com/images/248b5fa5a5e68683c9bd4287b984c714.png";